import {LeafletVectorSource} from '../classes/leaflet-vector-source';
import {LeafletMapLayer} from '../classes/leaflet-map-layer';
import {FeatureCollection, MultiPolygon, Point} from 'geojson';
import {Mapster, MapsterProperties} from '../classes/mapster';
import L from 'leaflet';
import {EilData} from '../../../classes/eil-data';
import {LayerStyleService} from '../services/layer-style.service';
import {LeafletFeature} from '../classes/leaflet-feature';
import {Survey123Feature} from '../../../classes/survey123-feature';

export class MapsterSource extends LeafletVectorSource {
    constructor(layerInfo: LeafletMapLayer) {
        super(layerInfo);
    }

    private getStyle(point: MapsterProperties): any {
        const key = `mapster`;
        let style = LayerStyleService.layerStyles.get(key);
        if (!style) {
            // const fillColor = point.active ? '#CCE7FD' : '#f3615a';
            const fillColor = '#f3615a';
            style = {
                radius: 6,
                fillColor,
                color: '#000',
                weight: 1,
                opacity: 1,
                fillOpacity: 0.8,
            };
            LayerStyleService.layerStyles.set(key, style);

            // const ele = new LegendElement();
            // ele.name = point.active ? 'Active' : 'Inactive';
            // ele.fillColor = fillColor;
            // ele.radius = 3;
            // ele.width = 20;
            // ele.height = 20;
        }
        return style;
    }

    processFeatures(features: FeatureCollection<MultiPolygon | Point, Mapster>): void {
        this.leafletFeatures = features.features
            .map((v) => new LeafletFeature<Mapster>(v).buildPopover(this.layerInfo))
            .sort((a, b) => {
                if (a.getGeometryType() > b.getGeometryType()) return -1;
                else if (a.getGeometryType() < b.getGeometryType()) return 1;
                return 0;
            });

        const pointStyle = (geoJsonPoint: any, latlng: L.LatLng): L.Layer => {
            return L.circleMarker(latlng, this.getStyle(geoJsonPoint.properties));
        };

        const singleFeaturePopover = (feature: LeafletFeature<Mapster>, l) => {
            this.initializePopoverInteractions(feature, l, 'click', false, undefined, feature);
        };

        const config: any = {
            pointToLayer: pointStyle,
            style: (feature: LeafletFeature<EilData>) => {
                return {
                    fillColor: '#2c7fb8',
                    color: '#000',
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 0.8,
                };
            },
            onEachFeature: singleFeaturePopover,
            maxZoom: 22,
        };

        this.source = L.geoJSON(this.leafletFeatures as any, config);
    }
}
